export interface SPARv2ValidAddress {
  street: string;
  postalCode: string;
  city: string;
  isValid: boolean;
}

interface SPARv2Address {
  ns2DatumFrom?: string;
  ns2DatumTill?: string;
  ns3Utdelningsadress2?: string;
  ns3PostNr?: string;
  ns3Postort?: string;
}

export interface SPARv2FolkbokforingsAddress {
  ns3SvenskAdress?: SPARv2Address;
}

// Helper functions for validation
const isNonEmptyString = (str: any): str is string =>
  typeof str === "string" && str.trim().length > 0;

export const isValidDate = (dateStr: string): boolean => {
  try {
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  } catch {
    return false;
  }
};

export const isAddressValid = (address: SPARv2Address): boolean => {
  return !!(
    isNonEmptyString(address.ns3Utdelningsadress2) &&
    isNonEmptyString(address.ns3PostNr) &&
    isNonEmptyString(address.ns3Postort) &&
    // Optional validation for postal code format
    /^\d{5}$/.test(address.ns3PostNr)
  );
};
